<template>
    <div id="gallery" class="section-gallery">
        <v-container>
            <span v-if="language==='EN'">
                <PageTitle :title="'Gallery'" :subtitle="subtitle_EN" :description="description_EN" />
            </span>
            <span v-if="language==='RU'">
                <PageTitle :title="'Галерея'" :subtitle="subtitle_RU" :description="description_RU" />
            </span>
            <span v-if="language==='UA'">
                <PageTitle :title="'Галерея'" :subtitle="subtitle_UA" :description="description_UA" />
            </span>
            <v-card class="mb-2">
                <v-card-title> <h3 class="title">2015</h3> </v-card-title>
                <v-card-text>
                    <ImageShooterGallery :directory="'gallery/2015'" :quantity="7" />
                </v-card-text>
            </v-card>  
            <v-card color="#020202" class="mb-2">
                <v-card-title> <h3 class="title white--text">2016</h3> </v-card-title>
                <v-card-text>
                    <ImageShooterGallery :directory="'gallery/2016'" :quantity="15" />
                </v-card-text>
            </v-card>  
            <v-card class="mb-2">
                <v-card-title> <h3 class="title">2017</h3> </v-card-title>
                <v-card-text>
                    <ImageShooterGallery :directory="'gallery/2017'" :quantity="11" />
                </v-card-text>
            </v-card>  
        </v-container>
    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle'
    import { MyFunctions } from '@/data/functions.js'
    import ImageShooterGallery from '@/components/ImageShooterGallery'

    export default {
    name: 'Portfolio',
        components: { PageTitle, ImageShooterGallery },
        data: () => ({
           language: '',
            
           subtitle_EN: '',
           subtitle_RU: '',
           subtitle_UA: '',

           description_EN: '',
           description_RU: '',
           description_UA: ''
       }),        
        mounted(){
            this.language = MyFunctions.getLanguage()
            this.setLayout('simple-layout')            
        },
        methods: {
            setLayout (layout) {
                this.$store.commit('setLayout', layout)
            }
        }
    }
</script>

<style>
    .section-gallery {
        margin-top: 65px!important;
        margin-bottom: 10px!important;
        margin: auto; 
        background-color: #ede8e1;
        -webkit-box-shadow: 0px 5px 3px 1px rgba(85, 85, 85, 0.1);
        box-shadow:  0px 5px 3px 1px rgba(0, 0, 0, 0.1);
        padding: 20px;
}
</style>


